import BackgroundPaper from "./BackgroundPaper";

export default BackgroundPaper;
